/**
 * Marks whether a deck-transition pane is the live incoming slide (CEE-1402).
 *
 * During the coupled push both panes stay mounted; the outgoing one must not report Next-gate
 * requirements or accept pointer input, or the host gate aggregates two slides at once.
 */
import { createContext, useContext, type ReactNode } from 'react';

const DeckPaneActiveContext = createContext(true);

export function DeckPaneProvider({
  active,
  children,
}: {
  active: boolean;
  children: ReactNode;
}) {
  return (
    <DeckPaneActiveContext.Provider value={active}>{children}</DeckPaneActiveContext.Provider>
  );
}

export function useDeckPaneActive(): boolean {
  return useContext(DeckPaneActiveContext);
}
